"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemVanitySlotText = void 0;
const Item_1 = require("../classes/Item");
const definables_1 = require("definables");
const getItemVanitySlotText = (itemID) => {
    const item = (0, definables_1.getDefinable)(Item_1.Item, itemID);
    if (item.hasClothesDye()) {
        return "Clothes Dye";
    }
    if (item.hasHairDye()) {
        return "Hair Dye";
    }
    if (item.hasMask()) {
        return "Mask";
    }
    if (item.hasOutfit()) {
        return "Outfit";
    }
    throw new Error("Item has no vanity");
};
exports.getItemVanitySlotText = getItemVanitySlotText;
